import { useState } from "react";
import { api } from "@/App";
import { toast } from "sonner";
import fuxIcon from "@/assets/fuxicon.svg";

export default function Login({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || loading) return;
    setLoading(true);
    try {
      await api.post("/auth/login", { password });
      onSuccess();
    } catch (err) {
      toast.error("Falsches Passwort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-page text-neutral-100 flex items-center justify-center px-4">
      <form
        onSubmit={handleSubmit}
        data-testid="login-form"
        className="w-full max-w-sm bg-panel border border-neutral-800 rounded-lg p-8 space-y-5"
      >
        <div className="flex items-center gap-1.5 mb-2">
          <span
            className="h-7 w-5 shrink-0 bg-[#D32222]"
            style={{
              WebkitMask: `url(${fuxIcon}) center / contain no-repeat`,
              mask: `url(${fuxIcon}) center / contain no-repeat`,
            }}
            aria-hidden="true"
          />
          <div>
            <div
              className="font-bold text-[21px] leading-none tracking-tight text-neutral-100"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              tool<span className="text-[#D32222]">FUX</span>
            </div>
          </div>
        </div>
        <div>
          <label
            className="block text-sm text-neutral-400 mb-1.5"
            htmlFor="login-password"
          >
            Passwort
          </label>
          <input
            id="login-password"
            data-testid="login-password-input"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-md bg-neutral-900 border border-neutral-700 px-3 py-2 text-sm text-neutral-100 focus:outline-none focus:ring-2 focus:ring-[#D32222]"
          />
        </div>
        <button
          type="submit"
          data-testid="login-submit"
          disabled={loading || !password}
          className="w-full rounded-md bg-[#D32222] hover:bg-[#E13636] disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium py-2 transition"
        >
          {loading ? "..." : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
